import { api } from "./api";
import type { BulkSyncResult } from "@/types/bulkSync";
import type { RawMaterialStock, StockBalance } from "@/types/models";

interface PaginatedResponse<T> {
  data: T[];
  meta: {
    total: number;
    limit: number;
    offset: number;
  };
}

export const stockService = {
  list: (params?: Record<string, string | number>) =>
    api
      .get<PaginatedResponse<RawMaterialStock>>("/raw-material-stock", {
        params,
      })
      .then((r) => r.data),
  get: (id: number) =>
    api
      .get<RawMaterialStock>(`/raw-material-stock/${id}`)
      .then((r) => r.data),
  create: (data: Partial<RawMaterialStock> & { attachment_ids?: number[] }) =>
    api
      .post<RawMaterialStock>("/raw-material-stock", data)
      .then((r) => r.data),
  bulkCreate: (data: Partial<RawMaterialStock>[]) =>
    api.post<BulkSyncResult<RawMaterialStock>>("/raw-material-stock/bulk", data).then((r) => r.data),
  update: (id: number, data: Partial<RawMaterialStock> & { attachment_ids?: number[] }) =>
    api
      .put<RawMaterialStock>(`/raw-material-stock/${id}`, data)
      .then((r) => r.data),
  // confirmPaid: the owner has seen "this bill has payments" and said delete.
  delete: (id: number, confirmPaid = false) =>
    api.delete(`/raw-material-stock/${id}`, { params: confirmPaid ? { confirm_paid: "true" } : undefined }),
  getBalances: () =>
    api
      .get<StockBalance[]>("/raw-material-stock/balances")
      .then((r) => r.data),
};
